var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"tw-mr-2 tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center"},[_c('img',{staticClass:"login",attrs:{"src":"img/manu.jpg"}})]),_vm._v(" "),_c('div',[_c('p',{staticClass:"login_text"},[_vm._v("Hello Mario")])])])
}]

export { render, staticRenderFns }